/**
 * While a meaning card expands into its detail view, the page keeps the list's scroll position
 * instead of jumping to the top: framer-motion measures shared elements in page coordinates, so a
 * scroll jump inside the same commit would make the card fly in from far below where the user sees
 * it. To keep the app looking like it is at the top of the page, the whole shell is nudged down by
 * the borrowed scroll offset for the length of the animation — navbar and sidebar included.
 *
 * A plain holder rather than state or context: `AppShell` re-renders on every navigation anyway, so
 * reading it during that render applies the offset in the same commit that mounts the detail view,
 * without a render of its own. Every write is paired with the matching DOM write in the page.
 */
export const appShellScrollFrame = { offset: 0 };
